import { takeLatest, call, put, fork, select } from 'redux-saga/effects'
import { userSelector } from 'auth/selectors'
import { verifyGuestCreditCardSuccess } from 'booking/actions'

import * as creditCardConstants from 'credit-cards/constants'
import * as creditCardActions from 'credit-cards/actions'
import * as creditCardApi from 'credit-cards/nAmApi'

import * as constants from 'credit-cards/moneris/constants'
import * as actions from 'credit-cards/moneris/actions'
import * as api from 'credit-cards/moneris/api'

function* monerisTokenizationSaga() {
    yield takeLatest(constants.ADD_CREDIT_CARD, function* ({ temporaryToken, nameOnCard }) {
        const user = yield select(userSelector)

        if (user) {
            const { token, accountKey } = user
            try {
                const response = yield call(api.createCCToken, temporaryToken, token, accountKey)
                const cardData = {
                    token: response.token,
                    lastFour: response.maskedPan.substr(-4),
                    expireMonth: response.expireMM,
                    expireYear: response.expireYYYY,
                    cardType: response.creditCardType,
                    nameOnCard: nameOnCard,
                }
                yield call(creditCardApi.saveCardData, accountKey, token, cardData)
                yield put(creditCardActions.addPaymentMethodSuccess(cardData))
            } catch (ex) {
                yield put(actions.addCreditCardFailure())
            }
        } else {
            const cardData = {
                token: temporaryToken,
                nickName: nameOnCard,
                id: 0,
            }
            yield put(verifyGuestCreditCardSuccess(cardData))
            yield put(creditCardActions.addPaymentMethodSuccess(cardData))
        }
    })
}

function* monerisPaymentSaga() {
    yield takeLatest(creditCardConstants.INIT_PAYMENT, function* () {
        yield put(creditCardActions.paymentSuccess())
    })
}

export function* rootSaga() {
    yield fork(monerisTokenizationSaga)
    yield fork(monerisPaymentSaga)
}
